export default __webpack_public_path__ + "f1af17909e877d4f1e848a6834f5d14c.svg";